import { z } from 'zod';

const KEY = 'first-table-map-view-state';

const viewStateSchema = z.object({
  latitude: z.number().gte(-180).lte(180),
  longitude: z.number().gte(-180).lte(180),
  zoom: z.number().gte(0).lte(22),
});

export function getSessionViewState(): ViewState | undefined {
  const sessionValue = sessionStorage.getItem(KEY);

  if (!sessionValue) {
    return;
  }

  const { success, data } = viewStateSchema.safeParse(JSON.parse(sessionValue));

  if (success) {
    return data as ViewState; // need to add "Required" to make sure the properties are required when TS strict mode isn't enabled (not needed when using TS strict mode).
  }
}

export function setSessionViewState(viewState: ViewState) {
  sessionStorage.setItem(KEY, JSON.stringify(viewState));
}

export function removeSessionViewState() {
  sessionStorage.removeItem(KEY);
}
